export default __webpack_public_path__ + "static/media/call.114040c9.svg";